// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"3f46388a","344":"e7a59b62","465":"0eb8db41","632":"3ca70eba","678":"a8a354d1","794":"e31fad04","991":"17131ccf"}[chunkId] + ".chunk.css";
};